var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlaylistX(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-playlist-x",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "currentColor",
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19 8h-14"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5 12h7"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12 16h-7"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M16 14l4 4"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M20 14l-4 4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlaylistX);
export default __webpack_public_path__ + "static/media/playlist-x.c1e52cbc.svg";
export { ForwardRef as ReactComponent };